/**
 * Quantas ações cabem no topo da conversa, e quantas ganham rótulo.
 *
 * Fica fora do componente porque é conta, não pintura: o desenho encolhe as
 * ações antes de deixar o nome do cliente sumir — primeiro some o rótulo, depois
 * o botão inteiro vai para o menu "mais". Errar aqui é o nome do cliente virando
 * reticências, e isso precisa de teste (`cabecalho.test.jsx`).
 */

const LARG_ICONE = 48;
const LARG_ROTULO = 112;

/**
 * Com TRÊS ações no topo (IA, Petição, Painel) os limiares são 760/560, e não
 * 1040/780 como na época em que eram cinco: num notebook de 1440 com o painel
 * aberto sobram 696px para a conversa, e ali cabe palavra — o cabeçalho de cinco
 * ícones mudos era consequência do orçamento, não do desenho.
 */
export function acoesQueCabem(defs, larguraPrincipal, celular) {
  const pisoNome = larguraPrincipal < 520 ? 120 : 180;
  const orcamento = larguraPrincipal - 32 - 40 - 10 - pisoNome - (celular ? 48 : 0);
  let comRotulo = larguraPrincipal >= 760 ? 2 : larguraPrincipal >= 560 ? 1 : 0;
  const cabem = [];
  let usado = 0;
  for (let i = 0; i < defs.length; i++) {
    const quer = cabem.length < comRotulo ? LARG_ROTULO : LARG_ICONE;
    const reserva = i < defs.length - 1 ? LARG_ICONE : 0;
    if (usado + quer + reserva <= orcamento) {
      cabem.push(defs[i]);
      usado += quer;
    } else break;
  }
  if (!cabem.length) {
    cabem.push(defs[0]);
    comRotulo = 0;
  }
  return { cabem, comRotulo, sobra: defs.slice(cabem.length) };
}

/**
 * A etapa depois da atual, lida do schema — nunca de uma lista escrita aqui.
 *
 * "A próxima linha da tabela" não é a próxima etapa em dois casos, e os dois
 * apareceram na auditoria de 22/08 com o caso já protocolado:
 *
 *   - etapa FINAL não tem seguinte. O funil acabou; oferecer avanço ali é
 *     oferecer saída do lugar onde o caso deve ficar.
 *   - a etapa de PERDA (final, sem ganho — "Desistência" de fábrica) nunca é
 *     avanço. Ela é a última linha da tabela por ordem, e o atalho de um clique
 *     do cabeçalho estava oferecendo "→ Desistência" a um processo protocolado.
 *     Desistir é decisão, e decisão se toma na lista de etapas da ficha, onde
 *     se escolhe de propósito e a pergunta diz o nome do que vai acontecer.
 *
 * `final` e `ganho` vêm do schema (`stages`), então isto continua valendo para
 * o funil que o escritório configurar amanhã.
 */
export const etapaSeguinte = (etapas, atual) => {
  const i = etapas.findIndex((e) => e.chave === atual);
  if (i < 0 || etapas[i]?.final) return null;
  const seguinte = etapas[i + 1] ?? null;
  const ePerda = seguinte?.final && !seguinte?.ganho;
  return seguinte && !ePerda ? seguinte : null;
};
